<template>
	<nav class="side-nav">
		<a class="filter" @click="clearFilter()" v-if="filters.length">
			<img src="images/filter.png" alt="필터"> 필터 초기화
		</a>
		<ul class="select clearfix m-b-10" v-if="filters.length">
			<li v-for="(filterItem, filterIndex) in filters" v-bind:key="hash(filterItem)">
				<p @click="toggleOpened(filterIndex)">
					<span class="select-text pull-left">{{ filterItem.filterName }}</span>
						<a v-bind:class="{toggle:true,on:filterItem.isOpen}"
							v-if="Array.isArray(filterItem.child) && filterItem.child.length>0">
							<img src="images/l-plus.png" alt="펼치기">
						</a>
				</p>
				<ul class="option" v-if="filterItem.isOpen" :class="filterItem.isOpen ? 'open' : ''">
					<li :class="filterItem.selectedAll ? 'on' : ''">
						<a @click="toggleSelectedAll(filterIndex)">전체선택</a>
					</li>
					<li v-for="(subfilter, subfilterIndex) in filterItem.child"
						v-bind:key="hash(subfilter)" :class="subfilter.selected ? 'on': ''">
						<a v-if="subfilter.type==''||subfilter.type=='사용자 입력 없음'" @click="toggleSelected(filterIndex, subfilterIndex)">{{ subfilter.filterName }}</a>
						<div v-if="subfilter.type=='날짜범위'">
							<a @click="toggleSelected(filterIndex, subfilterIndex)">{{ subfilter.filterName }}</a>
							<VueCtkDateTimePicker
								:no-value-to-custom-elem="true"
								:no-button-now="true"
								:no-header="true"
								:only-date="true"
								:format="'YYYY-MM-DD'"
								:minute-interval="10"
								v-model="subfilter.args[0]"
								@input="emitFilters(filterIndex, subfilterIndex)"
							>
								<input type="text" :value="subfilter.args[0]"/>
							</VueCtkDateTimePicker>
							<VueCtkDateTimePicker
								:no-value-to-custom-elem="true"
								:no-button-now="true"
								:no-header="true"
								:only-date="true"
								:format="'YYYY-MM-DD'"
								:minute-interval="10"
								v-model="subfilter.args[1]"
								@input="emitFilters(filterIndex, subfilterIndex)"
							>
								<input type="text" :value="subfilter.args[1]"/>
							</VueCtkDateTimePicker>
						</div>
					</li>
				</ul>
			</li>
		</ul>
	</nav>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import server from '../statics/server.js';
import axios from 'axios'

export default {
	name: "CtrlFilter",

	components: {
		VueCtkDateTimePicker
	},

	props: {
		listName: String
	},

	mounted: function() {
		this.getFilterData();
	},

	data: function() {
		return {
			filters: []
		}
	},

	methods: {
		// 필터 초기화
		clearFilter: function() {
			this.filters.forEach(filter => {
				filter.selectedAll = false;
				filter.child.forEach((subfilter) => {
					//subfilter.selected = false;
					this.$set(subfilter, "selected", false);
				})
			});
			this.emitFilters();
		},
		// 부모 컴포넌트에게 emit하는 메소드
		emitFilters: function(filterGrpIdx, filterItemIdx) {
			const emitValue = [];
			// filterGrp, filterItem 이 주어진 경우, 해당 필터의 args가 수정되었다는 뜻이므로 args의 존재여부에 따라서 체크표시를 반전해야 한다.
			if(filterGrpIdx!=undefined && filterItemIdx!=undefined) {
				if(this.filters[filterGrpIdx].child[filterItemIdx].args[0] || this.filters[filterGrpIdx].child[filterItemIdx].args[1])
					this.toggleSelected(filterGrpIdx, filterItemIdx, true);
				else
					this.toggleSelected(filterGrpIdx, filterItemIdx, false);
			}
			this.filters.forEach((filter) => {
				filter.child.forEach(subfilter => {
					if(subfilter.selected)
						emitValue.push({
							filterId: subfilter.filterId,
							args: subfilter.args
						});
				});
			});
			this.$emit("changeFilters", emitValue);
		},
		// 필터그룹 펼침/접힘 토글
		toggleOpened: function(filterIndex)
		{
			this.$set(this.filters[filterIndex], "isOpen", !this.filters[filterIndex].isOpen);
		},
		// 특정 필터그룹 내의 모든 필터항목 선택 토글
		toggleSelectedAll: function(filterIndex)
		{
			const resultBool = !this.filters[filterIndex].selectedAll;
			this.$set(this.filters[filterIndex], "selectedAll", resultBool);
			this.filters[filterIndex].child.forEach( (subfilter) => {
				this.$set(subfilter, "selected", resultBool)
			});
			this.emitFilters();
		},
		// 특정 필터그룹(category)내에 필터항목(filter) 선택 토글
		toggleSelected: function(filterIndex, subfilterIndex, value)
		{
			let resultBool = !this.filters[filterIndex].child[subfilterIndex].selected;
			if(value!=undefined) resultBool = value;
			if(!resultBool) this.$set(this.filters[filterIndex], "selectedAll", false);
			this.$set(this.filters[filterIndex].child[subfilterIndex], "selected", resultBool);
			const isSelecetedAll = this.filters[filterIndex].child.reduce((prev, curr) => (
				prev && curr.selected ? true : false
			), true); // 전체가 선택되어있는지 검색
			this.$set(this.filters[filterIndex], "selectedAll", isSelecetedAll);
			this.emitFilters();
		},
		// 필터링할 값을 서버에서 가져온다.
		getFilterData: async function() {
			try {
				const response = await axios.post(`${server.addr()}${server.api.FILTERS_ALL}`, {
					listName: this.listName
				});
				const { data } = response;
				this.filters = data.list.map((filterGroup) => {
					filterGroup.child.forEach((filterItem) => {
						if(!filterItem.args) filterItem.args = ["", ""];
					});
					return filterGroup;
				});
				this.emitFilters();
			} catch (e) {
				// TODO: error exception
			}
		}
	}
};

/**
	category: [
		분류id, 분류id, ...
	],
	filter: [
		// 사용자 입력이 없는 필터를 선택한 경우
		{
			id: 필터id
		},
		// 사용자 입력을 필요로하는 필터를 선택한 경우
		{
			id: 필터id,
			args: [사용자입력값1, 사용자입력값2, ...]
		},
		...
	]
 */
</script>

<style>
.option.open {
	display: block !important;
}
</style>